import * as React from 'react'
import { memo } from 'react'
const SvgX = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
    <path d="M.492 12 0 11.508 5.508 6 0 .492.492 0 6 5.508 11.508 0 12 .492 6.492 6 12 11.508l-.492.492L6 6.492Z" />
  </svg>
)
const Memo = memo(SvgX)
export default Memo
